import { render, staticRenderFns } from "./RegisterAdmissionformNewUser.vue?vue&type=template&id=ca258c0c&scoped=true"
import script from "./RegisterAdmissionformNewUser.vue?vue&type=script&lang=js"
export * from "./RegisterAdmissionformNewUser.vue?vue&type=script&lang=js"
import style0 from "./RegisterAdmissionformNewUser.vue?vue&type=style&index=0&id=ca258c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca258c0c",
  null
  
)

export default component.exports